import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { columnOrder } from 'apps/user/constants/shipments'
import { LegacyTableRow as TableRow } from 'components/atoms'
import { shortName } from 'utils/initials'
import { stopsSummary } from 'utils/shipmentHelpers'

export const ShipmentRow = memo(({ shipment }) => {
  const {
    id,
    status: { name },
    users: { dispatcherId, dispatcherName, driverId, driverName },
  } = shipment
  const { delivery, pickup } = stopsSummary(shipment)
  return (
    <TableRow
      columns={columnOrder}
      cells={{
        id: (
          <a
            href={`${__ROOT__}/shipment-details/${id}?tab=scheduling`}
            target='_blank'
            rel='noopener noreferrer'>
            {id}
          </a>
        ),
        pickups: <span>{pickup.dateFormatted}</span>,
        pickup: (
          <span>
            {pickup.city}, {pickup.state}
          </span>
        ),
        delivery: (
          <span>
            {delivery.city}, {delivery.state}
          </span>
        ),
        status: <span>{name}</span>,
        dispatcher: <Link to={`/${dispatcherId}`}>{shortName(dispatcherName)}</Link>,
        driver: <Link to={`/${driverId}`}>{shortName(driverName)}</Link>,
      }}
    />
  )
})

export const shipmentPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  status: PropTypes.shape({ name: PropTypes.string }).isRequired,
  users: PropTypes.shape({
    driverName: PropTypes.string,
    driverId: PropTypes.number,
    dispatcherName: PropTypes.string,
    dispatcherId: PropTypes.number,
  }).isRequired,
})

ShipmentRow.propTypes = {
  shipment: shipmentPropType.isRequired,
}
